/**
 * Cộng đồng (Community) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const CommunityPostsPage = lazy(() =>
  import("@/features/workspaces/module-pages").then((mod) => ({ default: mod.CommunityPostsPage })),
);
const GuestbookPage = lazy(() =>
  import("@/features/workspaces/module-pages").then((mod) => ({ default: mod.GuestbookPage })),
);
const GuestbookDetailPage = lazy(() =>
  import("@/features/guestbook/guestbook-detail-page").then((mod) => ({ default: mod.GuestbookDetailPage })),
);
const CommunityPostDetailPage = lazy(() =>
  import("@/features/community-posts/community-post-detail-page").then((mod) => ({ default: mod.CommunityPostDetailPage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const communityPostsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/cong-dong/bai-dang",
  component: withSuspense(CommunityPostsPage),
});
const communityPostDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/cong-dong/bai-dang/$publicId",
  component: withSuspense(CommunityPostDetailPage),
});

const guestbookRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/cong-dong/so-luu-niem",
  component: withSuspense(GuestbookPage),
});
const guestbookDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/cong-dong/so-luu-niem/$publicId",
  component: withSuspense(GuestbookDetailPage),
});

export const congDongRoutes = [
  communityPostsRoute,
  communityPostDetailRoute,
  guestbookRoute,
  guestbookDetailRoute,
];
